import React from "react";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";

const ButtonSecondary = ({button_text, width, height, padding, borderRadius, icon, icon_two, second_className, onClick, ...props}) => {
    return(
        <button className={`${classes.normal_button} ${classes[props.variant]} ${second_className}`} onClick={onClick}
            style={{width, height, padding, borderRadius}}
            {...props}
        >
            {icon}
            {button_text}
            {icon_two}
        </button>
    )
}

ButtonSecondary.propTypes = {
    button_text: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    padding: PropTypes.string,
    borderRadius: PropTypes.string,
    icon: PropTypes.node,
    icon_two: PropTypes.node,
    second_className: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string
};

export default ButtonSecondary;